/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for PermissionResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetPermissionCatalogResponse, GetPermissionAssignmentsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class PermissionResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getPermissionCatalog(resourceOptions: HttpResourceOptions<GetPermissionCatalogResponse, unknown> & { defaultValue: NoInfer<GetPermissionCatalogResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPermissionCatalogResponse>;
    getPermissionCatalog(resourceOptions?: HttpResourceOptions<GetPermissionCatalogResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPermissionCatalogResponse | undefined>;
    getPermissionCatalog(resourceOptions?: HttpResourceOptions<GetPermissionCatalogResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPermissionCatalogResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Permission`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getPermissionAssignments(resourceOptions: HttpResourceOptions<GetPermissionAssignmentsResponse, unknown> & { defaultValue: NoInfer<GetPermissionAssignmentsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPermissionAssignmentsResponse>;
    getPermissionAssignments(resourceOptions?: HttpResourceOptions<GetPermissionAssignmentsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPermissionAssignmentsResponse | undefined>;
    getPermissionAssignments(resourceOptions?: HttpResourceOptions<GetPermissionAssignmentsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPermissionAssignmentsResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Permission/assignments`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
